import { render, staticRenderFns } from "./textarea.pug?vue&type=template&id=13e29f8c&lang=pug&"
import script from "./textarea.js?vue&type=script&lang=js&"
export * from "./textarea.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e29f8c')) {
      api.createRecord('13e29f8c', component.options)
    } else {
      api.reload('13e29f8c', component.options)
    }
    module.hot.accept("./textarea.pug?vue&type=template&id=13e29f8c&lang=pug&", function () {
      api.rerender('13e29f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/textarea/index.vue"
export default component.exports